import { useEffect, useRef } from 'react';

/**
 * Adds an `is-visible` class to the attached element once it enters the
 * viewport. Pair with the `.reveal` utility class in global.css.
 */
export default function useScrollReveal(options = {}) {
  const ref = useRef(null);
  const { threshold = 0.18, rootMargin = '0px 0px -80px 0px', once = true } = options;

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            if (once) observer.unobserve(entry.target);
          } else if (!once) {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { threshold, rootMargin }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold, rootMargin, once]);

  return ref;
}
